module.exports = __webpack_public_path__ + "static/img/img_naverpay.dcd0c4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img_naverpay.png
// module id = 0VJU
// module chunks = 1